var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCreateTask = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 12",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.25 4.5L14.4 2.4C14.8 2.13 15.25 2.42 15.25 2.9V9.1C15.25 9.58 14.8 9.87 14.4 9.6L11.25 7.5M3 11.25H9C10.24 11.25 11.25 10.24 11.25 9V3C11.25 1.76 10.24 0.75 9 0.75H3C1.76 0.75 0.75 1.76 0.75 3V9C0.75 10.24 1.76 11.25 3 11.25Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgCreateTask;